module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row m-b-lg"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('account-credit')], 1), _vm._v(" "), (_vm.canAddCreditNotes) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-credit-note"
  }, _vm._l((_vm.creditNotes), function(creditNote) {
    return _c('li', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('p', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(creditNote.reference))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-2"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(creditNote.date))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-2"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v("CN#" + _vm._s(creditNote.code))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-2"
    }, [_c('p', {
      staticClass: "strong text-right"
    }, [_vm._v(_vm._s(creditNote.total))])])]), _vm._v(" "), _c('ul', {
      staticClass: "details"
    }, _vm._l((creditNote.itemsDecorated), function(item) {
      return _c('li', [_vm._v("\n              " + _vm._s(item.description) + " "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(item.currencyAmount))])])
    }))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoCreditNotes),
      expression: "haveNoCreditNotes"
    }],
    staticClass: "text-center text-muted m-t-md m-b-sm"
  }, [_c('strong', [_vm._v("There are no credit notes.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-credit-note",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          Add Credit Note\n        ")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row m-b-lg"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-decorate",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.profile.full_name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Reference Text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditNote.reference),
      expression: "creditNote.reference"
    }],
    staticClass: "form-control form-control-decorate",
    attrs: {
      "type": "text",
      "placeholder": "Reason for credit note..."
    },
    domProps: {
      "value": (_vm.creditNote.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditNote.reference = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h3', [_vm._v("Note Items")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_vm._l((_vm.creditNote.items), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-7"
    }, [_c('label', {
      staticClass: "sr-only"
    }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
      staticClass: "form-control form-control-decorate",
      attrs: {
        "type": "text",
        "placeholder": "Description..."
      },
      domProps: {
        "value": item.description
      },
      on: {
        "input": function($event) {
          _vm.updateCreditNoteItemDescription(index, $event)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 col-sm-3"
    }, [_c('label', {
      staticClass: "sr-only"
    }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(1, true), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "0.00"
      },
      domProps: {
        "value": item.amount
      },
      on: {
        "input": function($event) {
          _vm.updateCreditNoteItemAmount(index, $event)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-2"
    }, [_c('a', {
      staticClass: "btn btn-default btn-danger btn-circle pull-right",
      on: {
        "click": function($event) {
          _vm.removeCreditNoteItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-minus"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-7 col-sm-3"
  }, [_c('label', {
    staticClass: "sr-only"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.creditNoteItemTotal
    }
  })])])])], 2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs btn-primary",
    on: {
      "click": _vm.addCreditNoteItem
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Line")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSaveCreditNote
    }
  }, [_vm._v("Save")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-info btn-sm m-t-sm",
    attrs: {
      "href": "#modal-add-credit-note",
      "data-toggle": "modal",
      "data-target": "#modal-credit-note"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Credit\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-d3ae39f4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/CreditNotes.vue
// module id = 1078
// module chunks = 0